import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  ConvertPlaylistDto,
  ConvertPlaylistResponseDto,
  ConversionStatusDto,
  RematchRequestDto,
  PaginatedPlaylists,
  PlaylistDto,
  TokensDto
} from '../models/api.models';

@Injectable({
  providedIn: 'root'
})
export class PlaylistsService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  convertPlaylist(payload: ConvertPlaylistDto): Observable<ConvertPlaylistResponseDto> {
    return this.http.post<ConvertPlaylistResponseDto>(`${this.baseUrl}/playlists/convert`, payload);
  }

  listMine(page = 1, limit = 20): Observable<PaginatedPlaylists> {
    return this.http.get<PaginatedPlaylists>(`${this.baseUrl}/playlists/my`, { params: { page, limit } });
  }

  deleteMine(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/playlists/my/${id}`);
  }

  getConversionStatus(conversionId: string): Observable<ConversionStatusDto> {
    return this.http.get<ConversionStatusDto>(`${this.baseUrl}/playlists/conversions/${conversionId}/status`);
  }

  rematch(payload: RematchRequestDto): Observable<ConversionStatusDto> {
    return this.http.post<ConversionStatusDto>(`${this.baseUrl}/playlists/rematch`, payload);
  }

  getMyTokens(): Observable<TokensDto> {
    return this.http.get<TokensDto>(`${this.baseUrl}/playlists/tokens/me`);
  }
}
